/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import parse from "html-react-parser";

import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import moment from 'moment';
// import { isMobile } from "react-device-detect";
//import $ from 'jquery';
// import ReactPlayer from "react-player";
// import Slider from "react-slick";

// import Timer from "react-timer-wrapper";
// import Timecode from "react-timecode";

// import ItemBox from "../../components/aketo/ItemBox";

// import { now } from "lodash";

class Event2025_kaiju extends Component {
  state = {
    tabIndex: 0,
  };

  componentDidMount = () => {};

  render() {
    const { tabIndex } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="event_head">
          <h3>AGF2024</h3>
          <button type="button" className="btnClose">
            <img src={imgUrl + '/img/detail_img/close_1.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event220916_2" style={{ color: '#fff' }}>
            <img
              src={imgUrl + '/img/event/event2025_kaiju/img.png'}
              useMap="#image-map"
            />
          </div>
        </div>
        <map name="image-map">
          <area
            target="_blank"
            alt="팝업스토어 수원"
            title="팝업스토어 수원"
            href="https://m.lotteshopping.com/store/map?cstrCd=0349"
            coords="1660,2204,40,2687"
            shape="rect"
          />
          <area
            target="_blank"
            alt="팝업스토어 잠실"
            title="팝업스토어 잠실"
            href="https://www.lwt.co.kr/ko/about/location.do"
            coords="45,2723,1661,3214"
            shape="rect"
          />
        </map>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2025_kaiju));
